import styled from "styled-components";
import { AtiraTabs } from "../../../../components/AtiraTabs";
import { useTranslation } from "react-i18next";
import { TasksReadTab } from "../../../../components/tasks/TasksReadTab";
import { TaskKind } from "../../../../model/task/shared/TasksKind.enum";

const TaskTabs = styled(AtiraTabs)`
  padding-inline: 0;

  .ant-tabs-content,
  .ant-tabs-tabpane-active {
    height: 100%;
  }

  .ant-tabs-nav::before {
    display: none;
  }

  .ant-tabs-nav-list {
    width: 100% !important;
    justify-content: space-between !important;
  }

  .ant-tabs-tab {
    flex-grow: 1;
    justify-content: center;
    background-color: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    border-bottom: 2px solid transparent !important;
  }

  .ant-tabs-tab-btn:active,
  .ant-tabs-tab-btn:focus:not(:focus-visible) {
    color: ${({ theme }) => theme.main} !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    border-bottom-color: ${({ theme }) => theme.main} !important;
    color: ${({ theme }) => theme.main} !important;
  }

  .ant-tabs-tab:not(.ant-tabs-tab-active):hover {
    background-color: transparent !important;
    color: ${({ theme }) => theme.main} !important;
    border-bottom-color: ${({ theme }) => theme.lightMain} !important;
  }
`;

export const EntryDetailsDrawerTasksTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <TaskTabs
      items={[
        {
          key: "lead",
          label: t("common.lead_tasks"),
          children: <TasksReadTab kind={TaskKind.LEAD} />,
        },
        {
          key: "contact",
          label: t("common.contact_tasks"),
          children: <TasksReadTab kind={TaskKind.CONTACT} />,
        },
      ]}
    />
  );
};
